const CHANNEL_RANK = Object.freeze({
  ALL: 1,
  RETAIL: 2,
  FBA: 3,
  MFN: 4,
});

const stringComparison = (a, b) => {
  const string1 = a ? a : '';
  const string2 = b ? b : '';
  return string1.localeCompare(string2);
};

const compareByChannel = (a, b) => {
  const channelRank1 = a && a.channel ? CHANNEL_RANK[a.channel.toUpperCase()] : 0;
  const channelRank2 = b && b.channel ? CHANNEL_RANK[b.channel.toUpperCase()] : 0;
  return channelRank1 - channelRank2;
};

const compareByComponent = (a, b) => {
  return stringComparison(a.component, b.component);
};

const compareByProductLineId = (a, b) => {
  const productLineID1 = parseInt(a.productLineID);
  const productLineID2 = parseInt(b.productLineID);

  if (!isNaN(productLineID1) && isNaN(productLineID2)) {
    return -1;
  }

  if (isNaN(productLineID1) && !isNaN(productLineID2)) {
    return +1;
  }

  if (isNaN(productLineID1) && isNaN(productLineID2)) {
    return stringComparison(a.productLineID, b.productLineID);
  }

  return productLineID1 - productLineID2;
};

const COMPARISION_FIELDS = Object.freeze({
  COMPONENT: 'component',
  CHANNEL: 'channel',
  PRODUCT_LINE_ID: 'productLineID',
});

const COMPARISION_FUNCTIONS = Object.freeze({
  component: compareByComponent,
  channel: compareByChannel,
  productLineID: compareByProductLineId,
});

const compareBy = (a, b, comparisonFields) => {
  for (let i = 0; i < comparisonFields.length; ++i) {
    const comparisonFunction = COMPARISION_FUNCTIONS[comparisonFields[i]];
    const comparisonResult = comparisonFunction ? comparisonFunction(a, b) : 0;
    if (comparisonResult !== 0) {
      return comparisonResult;
    }
  }

  return 0;
};

export const sortByChannelComponent = (reportRows) => {
  const rowsClone = [...reportRows];
  rowsClone.sort((a, b) => {
    return compareBy(a, b, [COMPARISION_FIELDS.CHANNEL, COMPARISION_FIELDS.COMPONENT]);
  });
  return rowsClone;
};

export const sortByComponentProductLineChannel = (reportRows) => {
  const rowsClone = [...reportRows];
  rowsClone.sort((a, b) =>
    compareBy(a, b, [COMPARISION_FIELDS.COMPONENT, COMPARISION_FIELDS.PRODUCT_LINE_ID, COMPARISION_FIELDS.CHANNEL])
  );

  return rowsClone;
};



// WEBPACK FOOTER //
// ./src/components/reports/utils/sorting.js